import { Injectable } from '@angular/core';

import { Observable, switchMap } from 'rxjs';
import { ApiBaseService } from "../../common/providers/api-base-service";
import { Organization } from "../../common/models/organization";
import { Library } from "../../common/models/library";
import { CurrentUser } from "../../common/providers/current-user";
import { OrganizationsProvider } from "../../organizations/providers/organizations-provider";
import { ExercicesProvider } from "../../exercices/providers/exercices-provider";
import { map } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class LibraryService {

    public static readonly CONTEXT_ELITMENT = 1;
    public static readonly CONTEXT_ORGANIZATION = 2;
    public static readonly CONTEXT_USER = 3;

    constructor(
        private api: ApiBaseService,
        private organizationsProvider: OrganizationsProvider,
        private exercicesProvider: ExercicesProvider,
    ) {}

    public getByOrganizationCode(organizationCode: string): Observable<any> {
      return this.organizationsProvider.getByCode(organizationCode).pipe(
      ).pipe(
        switchMap((organization: Organization) => {
          return this.getByOrganization(organization);
        }),
      );
    }

    public get(organizationCode: string, id: number): Observable<Library> {
      return this.organizationsProvider.getByCode(organizationCode).pipe(
      ).pipe(
        switchMap((organization: Organization) => {
          return this.exercicesProvider.getLibraryById(organization.id!, id);
        }),
      );
    }

    public getByOrganization(organization: Organization): Observable<Library|null> {
      return this.getByOrganizationId(organization.id!)
    }

    public getByOrganizationId(organizationId: number): Observable<Library|null> {
      return this.exercicesProvider.getLibraries(organizationId!).pipe(
        map((libraries: Library[]) => {
          if (libraries.length === 0) {
            return null;
          }
          return libraries[0];
        }),
      );
    }
}
